import { gql } from '@apollo/client';

export const UPDATE_SELECTED_COMPANY = gql`
  mutation UpdateSelectedCompany($companyId: String!) {
    updateSelectedCompany(companyId: $companyId)
  }
`;
